<template>
    <div class="product">
        <div class="all">
            <div>更多分类产品请进入二级页面查看</div>
            <div>
                <div v-for="(item,index) in productList" :key="index">{{item.tagName}}</div>
            </div>
        </div>

        <div class="item" v-for="(item,index) in productList" :key="index">
            <div>{{item.tagName}}</div>
            <div>
                <div v-for="(i,n) in item.byProducts" :key="n">
                    <div v-for="(j,x) in i.pushFacMids" :key="x" @click="goProductDetails(item,i,j)">{{i.name}}-{{j.facCateName}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Product",
        data() {
            return {
                productList: []
            }
        },
        created() {
            this.getProduct();
        },
        methods: {
            goProductDetails(item, i, j) {
                this.$router.push({
                    path: '/product_details',
                    query: j
                })
            },
            getProduct() {
                this.request.get(this.$store.state.ryHttpUrl + "product/getProducts", {
                    params: {
                        businessNo: this.$store.state.orgCode
                    }
                }).then(res => {
                    if (res.status) {
                        this.productList = res.pageData;
                        this.$store.state.productList = res.pageData;
                    }
                });
            },
        }
    };
</script>

<style scoped>
    .product {
        background: #E5ECF9;
        text-align: left;
        width: 1200px;
        box-sizing: border-box;
        margin: 0 auto;
        padding-bottom: 50px;
    }

    .all>div:nth-child(1) {
        height: 64px;
        line-height: 62px;
        text-align: center;
        font-size: 16px;
        color: #666666;
        background: #FFE9E9;
        border-top: 2px solid #D50000;
        box-sizing: border-box;
    }

    .all>div:nth-child(2) {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        background: #FFFFFF;
        padding: 0px 24px 40px 24px;
    }

    .all>div:nth-child(2)>div {
        width: 140px;
        height: 40px;
        background: #F1F1F1;
        border-radius: 5px;
        text-align: center;
        line-height: 40px;
        font-size: 18px;
        color: #666666;
        margin-top: 40px;
    }

    .item {
        margin-top: 16px;
    }

    .item>div:nth-child(1) {
        height: 42px;
        line-height: 40px;
        text-align: left;
        font-size: 16px;
        color: #D50000;
        background: #FFE9E9;
        border-top: 2px solid #D50000;
        box-sizing: border-box;
        padding: 0 24px;
    }

    .item>div:nth-child(2) {
        display: flex;
        flex-wrap: wrap;
        background: #FFFFFF;
        padding: 0px 24px 20px 24px;
    }

    .item>div:nth-child(2)>div {
        display: flex;
        flex-wrap: wrap;
    }

    .item>div:nth-child(2)>div>div {
        width: 288px;
        margin-top: 20px;
        font-size: 14px;
        color: #666666;
    }

    .item>div:nth-child(2)>div>div:hover {
        color: #D50000;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/other/product.vue